import { z } from 'zod';

export const genderSchema = z.union([z.literal(0), z.literal(1), z.literal(2)]);

export const Gender = {
  0: 'female',
  1: 'male',
  2: 'secret',
} as const;
